/*
 * @Date: 2023-11-15 14:03:14
 * @email: 1098856043@qq.com
 * @LastEditors: j-wei
 * @LastEditTime: 2023-11-16 16:59:41
 */
import { createApp } from "vue";
import App from "./App.vue";
import "./assets/normalize.css";
import 'element-plus/dist/index.css'
import { ElInfiniteScroll } from "element-plus";
createApp(App).use(ElInfiniteScroll).mount("#app");
